import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { TrailerForm } from "./TrailerForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";

interface ITrailerCreateProps {}

export const TrailerCreate = (props: ITrailerCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Trailer,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-trailers.title.create">
        <TrailerForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
